import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=0036cf85&scoped=true"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"
import style0 from "./MedicalHistory.vue?vue&type=style&index=0&id=0036cf85&prod&scoped=true&lang=css"
import style1 from "./MedicalHistory.vue?vue&type=style&index=1&id=0036cf85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036cf85",
  null
  
)

export default component.exports